import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../../api";

import { Row, Col, CustomInput } from 'reactstrap';

import ParadigmaAsyncSeeker from "../../../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js";
import ParadigmaLabeledInput from "../../../../components/ParadigmaLabeledInput";


class Edit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            CasillaRemitente_id: null,

            EmailAdministracion: "",
            EmailPedidos: "",
            EmailMiscelaneos: "",

            ConsultaPorArticulo_Plantilla_id: null,
            OlvidoContraseña_Plantilla_id: null,
            Contacto_Plantilla_id: null,
            NotificacionEmpresaDeCreacionDePedido_Plantilla_id: null,
            NotificacionClienteDeCreacionDePedido_Plantilla_id: null,
            RegistroUsuario_Plantilla_id: null,
            RegistroCliente_Plantilla_id: null,

            ConsultaPorArticulo_Habilitado: false,
            OlvidoContraseña_Habilitado: false,
            Contacto_Habilitado: false,
            NotificacionEmpresaDeCreacionDePedido_Habilitado: false,
            NotificacionClienteDeCreacionDePedido_Habilitado: false,
            RegistroUsuario_Habilitado: false,
            RegistroCliente_Habilitado: false,

            postVariables: [
                "CasillaRemitente_id",
                "EmailAdministracion",
                "EmailPedidos",
                "EmailMiscelaneos",
                "ConsultaPorArticulo_Plantilla_id",
                "OlvidoContraseña_Plantilla_id",
                "Contacto_Plantilla_id",
                "NotificacionEmpresaDeCreacionDePedido_Plantilla_id",
                "NotificacionClienteDeCreacionDePedido_Plantilla_id",
                "RegistroUsuario_Plantilla_id",
                "RegistroCliente_Plantilla_id",
                "ConsultaPorArticulo_Habilitado",
                "OlvidoContraseña_Habilitado",
                "Contacto_Habilitado",
                "NotificacionEmpresaDeCreacionDePedido_Habilitado",
                "NotificacionClienteDeCreacionDePedido_Habilitado",
                "RegistroUsuario_Habilitado",
                "RegistroCliente_Habilitado",
            ],

            errors: [],
        };
    }

    static propTypes = {
        nav: PropTypes.any,
    }

    getData() {
        const { postVariables } = this.state;
        let data = {};
        postVariables.forEach(x => {
            data[x] = this.state[x];
        });
        return data;
    }

    resetForm() {
        this.setState({
            CasillaRemitente_id: null,

            EmailAdministracion: "",
            EmailPedidos: "",
            EmailMiscelaneos: "",

            ConsultaPorArticulo_Plantilla_id: null,
            OlvidoContraseña_Plantilla_id: null,
            Contacto_Plantilla_id: null,
            NotificacionEmpresaDeCreacionDePedido_Plantilla_id: null,
            NotificacionClienteDeCreacionDePedido_Plantilla_id: null,
            RegistroUsuario_Plantilla_id: null,
            RegistroCliente_Plantilla_id: null,

            ConsultaPorArticulo_Habilitado: false,
            OlvidoContraseña_Habilitado: false,
            Contacto_Habilitado: false,
            NotificacionEmpresaDeCreacionDePedido_Habilitado: false,
            NotificacionClienteDeCreacionDePedido_Habilitado: false,
            RegistroUsuario_Habilitado: false,
            RegistroCliente_Habilitado: false,

            errors: [],
        });
    }

    setData(data) {
        this.setState((prevState) => {
            const newState = data;
            prevState.postVariables.forEach(x => {
                prevState[x] = newState[x];
            });
            return prevState;
        });
    }

    setErrors(errors) {
        this.setState({
            errors: errors,
        });
    }

    onChangeField(field, value) {
        this.setState(prevState => {
            let errors = prevState.errors;
            if (errors) errors[field] = null;
            prevState.errors = errors;
            prevState[field] = value;
            return prevState;
        });
    }

    getError(field) {
        let errors = this.state.errors;
        if (errors) return errors[field];
        else return null;
    }

    toggleCheckActive = (field, value) => {
        this.onChangeField(field, !value);
    }


    render() {
        return (
            <ParadigmaModal
                navButton={true}
                nav={this.props.nav}
                getUrl={api.mails.config}
                submitUrl={api.mails.config}
                submitType={"PUT"}

                className={"modal-lg"}

                id={null}

                onGotData={(data) => this.setData(data)}
                onGotErrors={(errors) => this.setErrors(errors)}
                onSubmit={(e) => null}
                onClose={() => this.resetForm()}
                onPreSubmit={() => this.getData()}

                title={"Editar Configuración"}

                successMessage={"La Configuración ha sido editada con éxito."}
                missingIdMessage={"Debe seleccionar una fila."}
                buttonTitle={"Editar"}
                buttonIcon={"fa fa-pencil fa-lg"}
                saveButton={true}
                closeButton={true}
            >
                <Row className="mt-2">
                    <Col className="col-12 bg-dark text-white"><strong>Casillas de Origen y Emails de Destino</strong></Col>
                </Row>
                <ParadigmaLabeledInput
                    label={"Casilla Remitente (*)"}
                    md={[3, 9]}
                    inputComponent={<ParadigmaAsyncSeeker
                        clearable={true}
                        url={api.mails.casillas}
                        value={this.state.CasillaRemitente_id}
                        onChange={(data) => this.onChangeField('CasillaRemitente_id', (data ? data.id : null))}
                    />}
                    error={() => this.getError('casilla')}
                />
                <ParadigmaLabeledInput
                    md={[3, 9]}
                    maxLength={256}
                    label="Email de Administración (*)"
                    md={[3, 9]}
                    value={this.state.EmailAdministracion}
                    onChange={(e) => this.onChangeField('EmailAdministracion', e.target.value)}
                    error={() => this.getError('EmailAdministracion')}
                />
                <ParadigmaLabeledInput
                    md={[3, 9]}
                    maxLength={256}
                    label="Email para Miscelaneos"
                    md={[3, 9]}
                    value={this.state.EmailMiscelaneos}
                    onChange={(e) => this.onChangeField('EmailMiscelaneos', e.target.value)}
                    error={() => this.getError('EmailMiscelaneos')}
                />
                <ParadigmaLabeledInput
                    md={[3, 9]}
                    maxLength={256}
                    label="Email para Pedidos (*)"
                    md={[3, 9]}
                    value={this.state.EmailPedidos}
                    onChange={(e) => this.onChangeField('EmailPedidos', e.target.value)}
                    error={() => this.getError('EmailPedidos')}
                />
                <Row className="mt-2">
                    <Col className="col-12 bg-dark text-white"><strong>Eventos</strong></Col>
                </Row>

                <Row className="my-1">
                    <Col xs={12} className="bg-info text-white">Registro de Nuevo Usuario</Col>
                    <Col xs={10}>
                        <ParadigmaLabeledInput
                            label={"Plantilla"}
                            md={[2, 10]}
                            inputComponent={<ParadigmaAsyncSeeker
                                displayField="descripcion"
                                clearable={true}
                                url={api.mails.plantillas}
                                value={this.state.RegistroUsuario_Plantilla_id}
                                onChange={(data) => this.setState({ RegistroUsuario_Plantilla_id: (data ? data.id : null) })}
                            />}
                            error={() => this.getError('RegistroUsuario_Plantilla_id')}
                        />
                    </Col>
                    <Col xs={2} className="px-1 my-auto">
                        <CustomInput
                            type="checkbox"
                            id="RegistroUsuario_Habilitado"
                            label="Habilitar"
                            checked={this.state.RegistroUsuario_Habilitado}
                            onClick={(evt) => {
                                evt.preventDefault();
                                setTimeout(() => this.setState({ RegistroUsuario_Habilitado: !!!this.state.RegistroUsuario_Habilitado }), 100);
                            }}
                        />
                    </Col>
                </Row>

                <Row className="my-1">
                    <Col xs={12} className="bg-info text-white">Registro de Nuevo Cliente</Col>
                    <Col xs={10}>
                        <ParadigmaLabeledInput
                            label={"Plantilla"}
                            md={[2, 10]}
                            inputComponent={<ParadigmaAsyncSeeker
                                displayField="descripcion"
                                clearable={true}
                                url={api.mails.plantillas}
                                value={this.state.RegistroCliente_Plantilla_id}
                                onChange={(data) => this.setState({ RegistroCliente_Plantilla_id: (data ? data.id : null) })}
                            />}
                            error={() => this.getError('RegistroCliente_Plantilla_id')}
                        />
                    </Col>
                    <Col xs={2} className="px-1 my-auto">
                        <CustomInput
                            type="checkbox"
                            id="RegistroCliente_Habilitado"
                            label="Habilitar"
                            checked={this.state.RegistroCliente_Habilitado}
                            onClick={(evt) => {
                                evt.preventDefault();
                                setTimeout(() => this.setState({ RegistroCliente_Habilitado: !!!this.state.RegistroCliente_Habilitado }), 100);
                            }}
                        />
                    </Col>
                </Row>

                <Row className="my-1">
                    <Col xs={12} className="bg-info text-white">Olvido Contraseña</Col>
                    <Col xs={10}>
                        <ParadigmaLabeledInput
                            label={"Plantilla"}
                            md={[2, 10]}
                            inputComponent={<ParadigmaAsyncSeeker
                                displayField="descripcion"
                                clearable={true}
                                url={api.mails.plantillas}
                                value={this.state.OlvidoContraseña_Plantilla_id}
                                onChange={(data) => this.setState({ OlvidoContraseña_Plantilla_id: (data ? data.id : null) })}
                            />}
                            error={() => this.getError('OlvidoContraseña_Plantilla_id')}
                        />
                    </Col>
                    <Col xs={2} className="px-1 my-auto">
                        <CustomInput
                            type="checkbox"
                            id="OlvidoContraseña_Habilitado"
                            label="Habilitar"
                            checked={this.state.OlvidoContraseña_Habilitado}
                            onClick={(evt) => {
                                evt.preventDefault();
                                setTimeout(() => this.setState({ OlvidoContraseña_Habilitado: !!!this.state.OlvidoContraseña_Habilitado }), 100);
                            }}
                        />
                    </Col>
                </Row>

                <Row className="my-1">
                    <Col xs={12} className="bg-danger text-white">Notificacion a Empresa de Creacion de Pedido (*)</Col>
                    <Col xs={10}>
                        <ParadigmaLabeledInput
                            label={"Plantilla"}
                            md={[2, 10]}
                            inputComponent={<ParadigmaAsyncSeeker
                                displayField="descripcion"
                                clearable={true}
                                url={api.mails.plantillas}
                                value={this.state.NotificacionEmpresaDeCreacionDePedido_Plantilla_id}
                                onChange={(data) => this.setState({ NotificacionEmpresaDeCreacionDePedido_Plantilla_id: (data ? data.id : null) })}
                            />}
                            error={() => this.getError('NotificacionEmpresaDeCreacionDePedido_Plantilla_id')}
                        />
                    </Col>
                    <Col xs={2} className="px-1 my-auto">
                        <CustomInput
                            type="checkbox"
                            id="NotificacionEmpresaDeCreacionDePedido_Habilitado"
                            label="Habilitar"
                            checked={this.state.NotificacionEmpresaDeCreacionDePedido_Habilitado}
                            onClick={(evt) => {
                                evt.preventDefault();
                                setTimeout(() => this.setState({ NotificacionEmpresaDeCreacionDePedido_Habilitado: !!!this.state.NotificacionEmpresaDeCreacionDePedido_Habilitado }), 100);
                            }}
                        />
                    </Col>
                </Row>

                <Row className="my-1">
                    <Col xs={12} className="bg-danger text-white">Notificacion a Cliente de Creacion de Pedido (*)</Col>
                    <Col xs={10}>
                        <ParadigmaLabeledInput
                            label={"Plantilla"}
                            md={[2, 10]}
                            inputComponent={<ParadigmaAsyncSeeker
                                displayField="descripcion"
                                clearable={true}
                                url={api.mails.plantillas}
                                value={this.state.NotificacionClienteDeCreacionDePedido_Plantilla_id}
                                onChange={(data) => this.setState({ NotificacionClienteDeCreacionDePedido_Plantilla_id: (data ? data.id : null) })}
                            />}
                            error={() => this.getError('NotificacionClienteDeCreacionDePedido_Plantilla_id')}
                        />
                    </Col>
                    <Col xs={2} className="px-1 my-auto">
                        <CustomInput
                            type="checkbox"
                            id="NotificacionClienteDeCreacionDePedido_Habilitado"
                            label="Habilitar"
                            checked={this.state.NotificacionClienteDeCreacionDePedido_Habilitado}
                            onClick={(evt) => {
                                evt.preventDefault();
                                setTimeout(() => this.setState({ NotificacionClienteDeCreacionDePedido_Habilitado: !!!this.state.NotificacionClienteDeCreacionDePedido_Habilitado }), 100);
                            }}
                        />
                    </Col>
                </Row>

                <Row className="my-1">
                    <Col xs={12} className="bg-secondary text-white">Consulta por Artículo</Col>
                    <Col xs={10}>
                        <ParadigmaLabeledInput
                            label={"Plantilla"}
                            md={[2, 10]}
                            inputComponent={<ParadigmaAsyncSeeker
                                displayField="descripcion"
                                clearable={true}
                                url={api.mails.plantillas}
                                value={this.state.ConsultaPorArticulo_Plantilla_id}
                                onChange={(data) => this.setState({ ConsultaPorArticulo_Plantilla_id: (data ? data.id : null) })}
                            />}
                            error={() => this.getError('ConsultaPorArticulo_Plantilla_id')}
                        />
                    </Col>
                    <Col xs={2} className="px-1 my-auto">
                        <CustomInput
                            type="checkbox"
                            id="ConsultaPorArticulo_Habilitado"
                            label="Habilitar"
                            checked={this.state.ConsultaPorArticulo_Habilitado}
                            onClick={(evt) => {
                                evt.preventDefault();
                                setTimeout(() => this.setState({ ConsultaPorArticulo_Habilitado: !!!this.state.ConsultaPorArticulo_Habilitado }), 100);
                            }}
                        />
                    </Col>
                </Row>

                <Row className="my-1">
                    <Col xs={12} className="bg-secondary text-white">Contacto (*)</Col>
                    <Col xs={10}>
                        <ParadigmaLabeledInput
                            label={"Plantilla"}
                            md={[2, 10]}
                            inputComponent={<ParadigmaAsyncSeeker
                                displayField="descripcion"
                                clearable={true}
                                url={api.mails.plantillas}
                                value={this.state.Contacto_Plantilla_id}
                                onChange={(data) => this.setState({ Contacto_Plantilla_id: (data ? data.id : null) })}
                            />}
                            error={() => this.getError('Contacto_Plantilla_id')}
                        />
                    </Col>
                    <Col xs={2} className="px-1 my-auto">
                        <CustomInput
                            type="checkbox"
                            id="Contacto_Habilitado"
                            label="Habilitar"
                            checked={this.state.Contacto_Habilitado}
                            onClick={(evt) => {
                                evt.preventDefault();
                                setTimeout(() => this.setState({ Contacto_Habilitado: !!!this.state.Contacto_Habilitado }), 100);
                            }}
                        />
                    </Col>
                </Row>
            </ParadigmaModal>
        );
    }
}

export default Edit;



// WEBPACK FOOTER //
// ./src/views/Gestion/Sitio/Mails/Edit.js